import { render } from "./EntityViewSelector.vue?vue&type=template&id=5705dd9e&ts=true"
import script from "./EntityViewSelector.vue?vue&type=script&lang=ts"
export * from "./EntityViewSelector.vue?vue&type=script&lang=ts"

import "./EntityViewSelector.vue?vue&type=style&index=0&id=5705dd9e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__